import qs from "qs";

export const stringifyParams = (params, options = {}) =>
  qs.stringify(params, { addQueryPrefix: true, ...options });
